import { parseCampaignChannelKind } from './setupEventChannel';

export const CAMPAIGNS_HUB_PATH = '/admin/campaigns';
export const CAMPAIGN_NEW_PATH = '/admin/campaigns/new';
export const CAMPAIGN_TEMPLATES_PATH = '/admin/campaigns/templates';
export const NOTICE_PROGRAM_NEW_PATH = '/admin/campaigns/dispatches/new';
export const CONTACT_AGENT_PATH = '/admin/contact-agent';

export function noticeProgramNewPath(channelKind?: string): string {
  const kind = parseCampaignChannelKind(channelKind);
  if (!kind) {
    return NOTICE_PROGRAM_NEW_PATH;
  }
  return `${NOTICE_PROGRAM_NEW_PATH}?channelKind=${kind}`;
}

export function campaignDetailPath(campaignId: string): string {
  return `/admin/campaigns/${campaignId.slice(0, 64)}`;
}

export function campaignClonePath(campaignId: string): string {
  return `${CAMPAIGN_NEW_PATH}?from=${campaignId.slice(0, 64)}`;
}

export function noticeProgramDetailPath(programId: string): string {
  return `/admin/campaigns/dispatches/${programId.slice(0, 64)}`;
}

